import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

const SpanContainer = css`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;
export const Filter = styled('div')`
  ${SpanContainer}
  z-index: 1;
  background: ${({ theme }) => theme.color.charcoalRGBA(0.6)};
`;
export const Container = styled('picture')`
  ${SpanContainer}
  z-index: 0;
`;

export const StyledImg = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
  ${media.lgUp`
    border-bottom-right-radius: ${({ theme }) => theme.x1spacePx}px;
    border-bottom-left-radius: ${({ theme }) => theme.x1spacePx}px;
  `}
`;
